/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/AvataxTrustfileSummary.js
 */

import React from 'react';

const AvataxTrustfileSummary = (data) => {
  return (
    <div className="DeliveryResultsSection">
      <div className="ResultItem">
        <div className="ResultLabel">Trustfile Account Id</div>
        <div className="ResultValue">{data.id}</div>
      </div>

      <div className="ResultItem">
        <div className="ResultLabel">Trustfile Account Status</div>
        <div className="ResultValue">
          {data.status ? data.status : 'Not available'}
        </div>
      </div>
    </div>
  );
};

export default AvataxTrustfileSummary;
